import Manager from './manager';

const manager = new Manager();

// window.addEventListener("load", function (e) {
//     manager.init("landing");
// });
Pace.on('done', function(){
    if(manager.status.execution == "landing"){
        manager.init();
    }
});

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */


window.addEventListener("scroll", function (e) {
    let _y = window.pageYOffset || document.documentElement.scrollTop;
    if(manager && manager.status.loaded) manager.scroll.update(_y,"");
});

window.addEventListener("mousemove",function (e) {

    let _x = e.clientX;
    let _y = e.clientY;

    if(manager) if(manager.mouse) manager.mouse.update(_x,_y);

});

let MOUSE_WHEEL_EVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

document.addEventListener(MOUSE_WHEEL_EVENT,function(e){

    if(manager) manager.wheel(e);

},{passive: false});


window.addEventListener("resize",function (e) {
    // executionType = "resize";

    if(manager){

        if(manager.param.displayType=="sp"&&manager.w == window.innerWidth) return;
        manager.resize();
    }
});

if(Useragnt.mobile||manager.isIpad){
    window.addEventListener("touchstart",function (e) {
        if(manager) manager.touchStart(e);
    });
    window.addEventListener("touchmove",function (e) {

        if(manager) manager.touchmove(e);

    }, { passive: false });
    window.addEventListener("touchend",function (e) {
        if(manager) manager.touchEnd(e);
    });
    window.addEventListener("orientationchange",function (e) {
        // executionType = "onorientationchange";
        // if(manager) manager.resize();
        if(manager) manager.orientation();
    });
    window.addEventListener("deviceorientation",(e)=>{
        // X軸
        const beta = e.beta;
        // Y軸
        const gamma = e.gamma;
        // Z軸
        const alpha = e.alpha;
    });
}